import type * as React from 'react';
import { del } from '@Domain/Api';
import organizationDeleted, {
	type OrganizationDeletedAction,
} from '@Application/Organizations/Organizations/Actions/organizationDeleted';
import organizationDeletionFailed, {
	type OrganizationDeletionFailedAction,
} from '@Application/Organizations/Organizations/Actions/organizationDeletionFailed';
import type DeleteOrganization from '@Application/Organizations/Organizations/Commands/DeleteOrganization';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationDeletedAction | OrganizationDeletionFailedAction;

export default (command: DeleteOrganization) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/organizations/${command.organizationId}`,
			);

			const action = organizationDeleted({ organizationId: command.organizationId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
